import { type Dispatch, type ReactNode, createContext, useReducer } from "react";
import type { Action, AuthContext as AuthContextType } from "./authInterfaces";
import userDataReducer from "./userDataReducer";

interface IProps {
  children: ReactNode;
}

const dummyReducer: Dispatch<Action> = () => null;
const initState = { loading: true, user: null };

export const AuthContext = createContext<AuthContextType>(initState);
export const AuthMutatorContext = createContext<any>(dummyReducer);

const AuthContextProvider = (props: IProps) => {
  const [userData, dispatch] = useReducer<any, any>(userDataReducer, initState);

  return (
    <AuthContext.Provider value={userData}>
      <AuthMutatorContext.Provider value={dispatch}>{props.children}</AuthMutatorContext.Provider>
    </AuthContext.Provider>
  );
};
export default AuthContextProvider;
